module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/071-7336c944ef521aaa3155ea0e50a60978.jpg";